export const TAG = {
    EVENTS_LIST: 'EVENTS_LIST_COMPONENT',
    EVENTS_DETAIL: 'EVENTS_DETAIL',
    BUTTON_LOCKED: 'BUTTON_LOCKED',
    EVENT_MODERATOR: 'EVENT_MODERATOR',
    COURSE_MODERATOR: 'COURSE_MODERATOR',
    COURSE_FORM: 'COURSE_FORM',
    COURSE_PUBLISH: 'COURSE_PUBLISH',
    FACEBOOK_FEEDS: 'FACEBOOK_FEEDS',
    MESSAGE_MODAL: 'MESSAGE_MODAL',
};